import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-input flex items-center rounded border border-solid border-dividers-default bg-background-default" }
const _hoisted_2 = { class: "search-input__icon search-input__icon--left ml-2 box-border usn relative" }
const _hoisted_3 = { class: "search-input__control ml-2" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "search-input__dot w-2 h-2 mr-4 pointer-events-none" }
const _hoisted_6 = { class: "rounded-full w-2 h-2 bg-blue-500" }

import { ref, onUnmounted, watch, onMounted } from 'vue';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import { globalState } from '@/utilities/globalState';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBoard',
  emits: ['input', 'enter', 'clear'],
  setup(__props, { emit: __emit }) {

const { iconPath, getCustomIconStyle } = useCustomIcon();

const emit = __emit;

const searchInput = ref<HTMLInputElement | null>(null);
const searchQuery = ref('');
let debounceTimeout: NodeJS.Timeout | null = null;
let isInternalUpdate = false;

const handleInput = () => {
  // Debounce the global state update
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
  }
  isInternalUpdate = true;
  debounceTimeout = setTimeout(() => {
    globalState.searchBoardQuery = searchQuery.value;
    isInternalUpdate = false;
  }, 200);

  emit('input', searchQuery.value);
};

// Watch for changes in globalState.searchBoardQuery
watch(
  () => globalState.searchBoardQuery,
  (newValue) => {
    if (!isInternalUpdate) {
      searchQuery.value = newValue;
    }
  }
);

const handleEnter = () => {
  emit('enter', searchQuery.value);
};

const handleEsc = () => {
  searchQuery.value = '';
  emit('clear');
};

const focusInput = () => {
  searchInput.value?.focus();
};

onMounted(() => {
  globalState.searchBoardQuery = '';
});

onUnmounted(() => {
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
  }
  globalState.searchBoardQuery = '';
});

return (_ctx: any,_cache: any) => {
  return (!_ctx.isMobile)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "search-board-container py-3 px-4 pr-1 electron-no-drag",
        onClick: focusInput
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("em", {
              class: "bg-icon-default m-auto block h-4 w-4",
              style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('search-alternative')))
            }, null, 4)
          ]),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "searchInput",
              ref: searchInput,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              placeholder: `${_ctx.translate('search')} ${_ctx.translate('cards').toLowerCase()}...`,
              class: "search-input__field border-0 bg-transparent text-text-default placeholder:text-text-placeholder border-box focus:outline-none text-sm",
              onInput: handleInput,
              onKeyup: [
                _withKeys(handleEnter, ["enter"]),
                _withKeys(handleEsc, ["esc"])
              ]
            }, null, 40, _hoisted_4), [
              [_vModelText, searchQuery.value]
            ])
          ]),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
              [_vShow, searchQuery.value]
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})